// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&family=Syne:wght@400;700;800&family=DM+Mono:wght@400;500&family=Source+Serif+4:ital,wght@0,400;0,600;0,700;1,400&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/katex.min.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Tutorial3.css  —  KinetiQ CRE Course Notes · Lecture 3
   Same design system as Tutorial1.css.
   Scoped under .cre3- prefix to avoid collisions.
   ============================================================ */
   
   /* ─── Design tokens ──────────────────────────────────────────────── */
   :root {
     --t3-bg:              #e4ecf3;
     --t3-surface:         #ffffff;
     --t3-panel:           #f5f1ed;
     --t3-card:            #ffffff;
     --t3-sidebar-bg:      #f0ebe4;
     --t3-sidebar-header:  #e8e2da;
     --t3-code-bg:         #fdf7ef;
     --t3-eq-bg:           #faf5ee;
   
     --t3-accent:          #28a745;
     --t3-accent-dim:      rgba(40, 167, 69, 0.10);
     --t3-accent-glow:     rgba(40, 167, 69, 0.22);
     --t3-accent-hover:    #1f8836;
   
     --t3-amber:           #e89c00;
     --t3-amber-dim:       rgba(232, 156, 0, 0.10);
     --t3-amber-border:    rgba(232, 156, 0, 0.28);
     --t3-cyan:            #0ab5e2;
     --t3-cyan-dim:        rgba(10, 181, 226, 0.10);
     --t3-cyan-border:     rgba(10, 181, 226, 0.25);
     --t3-blue:            #4a90d9;
     --t3-blue-dim:        rgba(74, 144, 217, 0.10);
     --t3-blue-border:     rgba(74, 144, 217, 0.28);
     --t3-green-dim:       rgba(40, 167, 69, 0.08);
     --t3-green-border:    rgba(40, 167, 69, 0.25);
     --t3-red:             #c0392b;
     --t3-red-dim:         rgba(192, 57, 43, 0.08);
     --t3-red-border:      rgba(192, 57, 43, 0.25);
     --t3-purple:          #8e44ad;
     --t3-purple-dim:      rgba(142, 68, 173, 0.08);
     --t3-purple-border:   rgba(142, 68, 173, 0.25);
   
     --t3-batch:           #e89c00;
     --t3-cstr:            #e0603a;
     --t3-pfr:             #4a90d9;
     --t3-pbr:             #28a745;
   
     --t3-border:          #cfc4b8;
     --t3-border-light:    #e5dbd0;
     --t3-border-mid:      #bbb0a4;
   
     --t3-text:            #1a1209;
     --t3-text-muted:      #3a2f28;
     --t3-text-mid:        #4a3f38;
     --t3-text-dim:        #6a5f58;
     --t3-text-sub:        #8a7e76;
   
     --t3-font-mono:   'DM Mono', 'JetBrains Mono', monospace;
     --t3-font-ui:     'DM Sans', 'Segoe UI', system-ui, sans-serif;
     --t3-font-brand:  'Syne', sans-serif;
     --t3-font-serif:  'Source Serif 4', Georgia, serif;
   
     --t3-space-xs:  6px;
     --t3-space-sm:  10px;
     --t3-space-md:  16px;
     --t3-space-lg:  24px;
     --t3-space-xl:  40px;
     --t3-space-2xl: 56px;
   
     --t3-radius-sm: 5px;
     --t3-radius-md: 9px;
     --t3-radius-lg: 13px;
   
     --t3-sidebar-w: 268px;
   }
   
   /* ─── Reset ──────────────────────────────────────────────────────── */
   *,
   *::before,
   *::after {
     box-sizing: border-box;
     margin: 0;
     padding: 0;
   }
   
   /* ─── Scrollbar ──────────────────────────────────────────────────── */
   ::-webkit-scrollbar        { width: 5px; height: 5px; }
   ::-webkit-scrollbar-track  { background: transparent; }
   ::-webkit-scrollbar-thumb  { background: var(--t3-border); border-radius: 3px; }
   ::-webkit-scrollbar-thumb:hover { background: var(--t3-border-mid); }
   
   /* ══════════════════════════════════════════════════════════════
      CONTAINER
   ══════════════════════════════════════════════════════════════ */
   .cre3-container {
     font-family: var(--t3-font-ui);
     background:  var(--t3-bg);
     color:       var(--t3-text);
     display:     flex;
     height:      100%;
     width:       100%;
     font-size:   15px;
     line-height: 1.7;
     overflow:    hidden;
   }
   
   /* ══════════════════════════════════════════════════════════════
      SIDEBAR
   ══════════════════════════════════════════════════════════════ */
   .cre3-sidebar {
     display:        none;
     width:          var(--t3-sidebar-w);
     min-width:      var(--t3-sidebar-w);
     background:     var(--t3-sidebar-bg);
     border-right:   1px solid var(--t3-border);
     height:         100%;
     overflow-y:     auto;
     padding-bottom: 40px;
     font-size:      13px;
     flex-shrink:    0;
     position:       relative;
   }
   
   @media (min-width: 1400px) {
     .cre3-sidebar { display: block; }
   }
   
   .cre3-sidebar-header {
     background:    var(--t3-sidebar-header);
     padding:       20px 18px 16px;
     border-bottom: 1px solid var(--t3-border);
     position:      sticky;
     top:           0;
     z-index:       10;
   }
   
   .cre3-sidebar-header h1 {
     font-family:    var(--t3-font-mono);
     font-size:      11px;
     text-transform: uppercase;
     letter-spacing: 2px;
     color:          var(--t3-accent);
     margin-bottom:  4px;
     font-weight:    500;
   }
   
   .cre3-sidebar-header p {
     font-size: 12px;
     color:     var(--t3-text-muted);
   }
   
   .cre3-nav-section {
     padding:        14px 0 4px 18px;
     font-family:    var(--t3-font-mono);
     font-size:      10px;
     text-transform: uppercase;
     letter-spacing: 2px;
     color:          var(--t3-amber);
     margin-top:     8px;
     font-weight:    500;
   }
   
   .cre3-nav-item {
     display:      block;
     padding:      7px 18px 7px 28px;
     color:        var(--t3-text-muted);
     text-decoration: none;
     border-left:  3px solid transparent;
     transition:   all 0.15s;
     line-height:  1.4;
     cursor:       pointer;
   }
   .cre3-nav-item:hover {
     color:             var(--t3-text);
     background:        rgba(40, 167, 69, 0.06);
     border-left-color: var(--t3-accent);
   }
   .cre3-nav-item--sub {
     padding-left: 40px;
     font-size:    12px;
     color:        var(--t3-text-dim);
   }
   
   /* ══════════════════════════════════════════════════════════════
      MAIN CONTENT
   ══════════════════════════════════════════════════════════════ */
   .cre3-main {
     flex:       1 1;
     overflow-y: auto;
     overflow-x: hidden;
     min-width:  0;
     animation:  fadeIn3 0.3s ease;
   }
   
   .cre3-main-inner {
     margin:  0 auto;
     padding: 48px 56px 80px;
   }
   
   /* ─── Hero ───────────────────────────────────────────────────────── */
   .cre3-hero {
     margin-bottom:  var(--t3-space-2xl);
     padding-bottom: 32px;
     border-bottom:  1px solid var(--t3-border-light);
   }
   
   .cre3-hero-tag {
     font-family:    var(--t3-font-mono);
     font-size:      11px;
     text-transform: uppercase;
     letter-spacing: 3px;
     color:          var(--t3-amber);
     margin-bottom:  12px;
   }
   
   .cre3-hero h1 {
     font-family:   var(--t3-font-serif);
     font-size:     38px;
     font-weight:   700;
     line-height:   1.2;
     margin-bottom: 12px;
     color:         var(--t3-text);
   }
   
   .cre3-hero-desc {
     color:     var(--t3-text-muted);
     font-size: 16px;
     max-width: 600px;
     line-height: 1.6;
   }
   
   .cre3-hero-meta {
     display:    flex;
     gap:        24px;
     margin-top: 20px;
     flex-wrap:  wrap;
   }
   
   .cre3-meta-item {
     font-family: var(--t3-font-mono);
     font-size:   11px;
     color:       var(--t3-text-dim);
     display:     flex;
     align-items: center;
     gap:         6px;
   }
   
   .cre3-meta-dot {
     width:         6px;
     height:        6px;
     border-radius: 50%;
     background:    var(--t3-accent);
     display:       inline-block;
   }
   
   /* ─── TOC ────────────────────────────────────────────────────────── */
   .cre3-toc-box {
     background:    var(--t3-surface);
     border:        1px solid var(--t3-border-light);
     border-radius: var(--t3-radius-lg);
     padding:       24px 28px;
     margin-bottom: var(--t3-space-2xl);
   }
   
   .cre3-toc-box h3 {
     font-family:    var(--t3-font-mono);
     font-size:      11px;
     text-transform: uppercase;
     letter-spacing: 2px;
     color:          var(--t3-text-sub);
     margin-bottom:  14px;
   }
   
   .cre3-toc-grid {
     display:               grid;
     grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
     gap:                   6px 12px;
   }
   
   .cre3-toc-link {
     font-size:      13px;
     color:          var(--t3-blue);
     text-decoration: none;
     padding:        4px 8px;
     border-radius:  var(--t3-radius-sm);
     transition:     background 0.15s;
   }
   .cre3-toc-link:hover { background: var(--t3-blue-dim); }
   
   /* ─── Lecture badge ──────────────────────────────────────────────── */
   .cre3-lec-badge {
     display:        inline-block;
     font-family:    var(--t3-font-mono);
     font-size:      10px;
     text-transform: uppercase;
     letter-spacing: 2px;
     padding:        3px 10px;
     border-radius:  20px;
     margin-bottom:  10px;
     font-weight:    500;
   }
   .cre3-lec-badge--lec1 { background: var(--t3-amber-dim);  color: var(--t3-amber);  border: 1px solid var(--t3-amber-border); }
   .cre3-lec-badge--lec3 { background: var(--t3-blue-dim);   color: var(--t3-blue);   border: 1px solid var(--t3-blue-border); }
   .cre3-lec-badge--rate { background: var(--t3-purple-dim); color: var(--t3-purple); border: 1px solid var(--t3-purple-border); }
   .cre3-lec-badge--arrh { background: var(--t3-green-dim);  color: var(--t3-accent); border: 1px solid var(--t3-green-border); }
   .cre3-lec-badge--ref  { background: var(--t3-cyan-dim);   color: var(--t3-cyan);   border: 1px solid var(--t3-cyan-border); }
   
   /* ─── Section ────────────────────────────────────────────────────── */
   .cre3-section {
     margin-bottom:  var(--t3-space-2xl);
     scroll-margin-top: 20px;
   }
   
   .cre3-section-label {
     font-family:    var(--t3-font-mono);
     font-size:      10px;
     text-transform: uppercase;
     letter-spacing: 2.5px;
     color:          var(--t3-accent);
     margin-bottom:  6px;
   }
   
   .cre3-section h2 {
     font-family:   var(--t3-font-serif);
     font-size:     26px;
     font-weight:   700;
     color:         var(--t3-text);
     margin-bottom: 6px;
     line-height:   1.3;
   }
   
   .cre3-section-divider {
     width:         40px;
     height:        3px;
     background:    var(--t3-accent);
     margin-bottom: 22px;
     border-radius: 2px;
   }
   
   .cre3-section h3 {
     font-family:  var(--t3-font-serif);
     font-size:    18px;
     font-weight:  600;
     color:        var(--t3-text-mid);
     margin:       28px 0 10px;
   }
   
   .cre3-section h4 {
     font-family:  var(--t3-font-ui);
     font-size:    15px;
     font-weight:  600;
     color:        var(--t3-text-mid);
     margin:       18px 0 8px;
   }
   
   .cre3-section p {
     margin-bottom: 14px;
     color:         var(--t3-text-muted);
     line-height:   1.75;
   }
   
   .cre3-section ul,
   .cre3-section ol {
     padding-left:  20px;
     margin-bottom: 14px;
     color:         var(--t3-text-muted);
   }
   
   .cre3-section li { margin-bottom: 6px; }
   
   /* ─── Equation box ───────────────────────────────────────────────── */
   .cre3-eq-box {
     background:    var(--t3-eq-bg);
     border:        1px solid var(--t3-border-light);
     border-left:   4px solid var(--t3-amber);
     border-radius: var(--t3-radius-md);
     padding:       20px 24px;
     margin:        18px 0;
     overflow-x:    auto;
   }
   
   .cre3-eq-box--blue   { border-left-color: var(--t3-blue);   background: var(--t3-blue-dim); }
   .cre3-eq-box--green  { border-left-color: var(--t3-accent); background: var(--t3-green-dim); }
   .cre3-eq-box--purple { border-left-color: var(--t3-purple); background: var(--t3-purple-dim); }
   .cre3-eq-box--red    { border-left-color: var(--t3-red);    background: var(--t3-red-dim); }
   
   .cre3-eq-label {
     font-size:      10px;
     font-family:    var(--t3-font-mono);
     text-transform: uppercase;
     letter-spacing: 2px;
     color:          var(--t3-text-dim);
     margin-bottom:  10px;
   }
   
   .cre3-eq-main {
     font-family: var(--t3-font-mono);
     font-size:   15px;
     color:       var(--t3-blue);
     line-height: 2;
   }
   
   /* KaTeX override: ensure formulas render at comfortable size */
   .cre3-eq-main .katex { font-size: 1.15em; }
   .cre3-eq-box .katex  { font-size: 1.1em; }
   
   .cre3-eq-note {
     font-size:   12.5px;
     color:       var(--t3-text-dim);
     margin-top:  10px;
     line-height: 1.6;
   }
   
   /* ─── Equation grid for reactor table ───────────────────────────── */
   .cre3-reactor-table {
     width:           100%;
     border-collapse: collapse;
     margin:          20px 0;
     font-size:       13.5px;
     background:      var(--t3-surface);
     border-radius:   var(--t3-radius-md);
     overflow:        hidden;
     border:          1px solid var(--t3-border-light);
   }
   
   .cre3-reactor-table thead {
     background: var(--t3-panel);
   }
   
   .cre3-reactor-table th {
     padding:        11px 16px;
     text-align:     left;
     font-family:    var(--t3-font-mono);
     font-size:      10px;
     text-transform: uppercase;
     letter-spacing: 1.5px;
     color:          var(--t3-text-muted);
     border-bottom:  1px solid var(--t3-border);
     font-weight:    500;
   }
   
   .cre3-reactor-table td {
     padding:       12px 16px;
     border-bottom: 1px solid var(--t3-border-light);
     color:         var(--t3-text-muted);
     vertical-align: middle;
   }
   
   .cre3-reactor-table tr:last-child td { border-bottom: none; }
   .cre3-reactor-table tr:hover td { background: rgba(40,167,69,0.03); }
   
   .cre3-reactor-table .katex { font-size: 1.05em; }
   
   /* Reactor label chips */
   .cre3-reactor-chip {
     display:        inline-block;
     font-family:    var(--t3-font-mono);
     font-size:      10px;
     text-transform: uppercase;
     letter-spacing: 1.5px;
     padding:        3px 9px;
     border-radius:  20px;
     font-weight:    600;
   }
   .cre3-chip--batch { background: rgba(232,156,0,0.12);  color: var(--t3-batch); }
   .cre3-chip--cstr  { background: rgba(224,96,58,0.12);  color: var(--t3-cstr); }
   .cre3-chip--pfr   { background: var(--t3-blue-dim);    color: var(--t3-pfr); }
   .cre3-chip--pbr   { background: var(--t3-green-dim);   color: var(--t3-pbr); }
   
   /* ─── Callout boxes ──────────────────────────────────────────────── */
   .cre3-callout {
     border-radius: var(--t3-radius-md);
     padding:       14px 18px;
     margin:        18px 0;
     font-size:     14px;
     line-height:   1.65;
   }
   .cre3-callout p  { color: var(--t3-text-muted); margin: 0; }
   .cre3-callout--key    { background: var(--t3-blue-dim);   border: 1px solid var(--t3-blue-border); }
   .cre3-callout--warn   { background: var(--t3-amber-dim);  border: 1px solid var(--t3-amber-border); }
   .cre3-callout--tip    { background: var(--t3-green-dim);  border: 1px solid var(--t3-green-border); }
   .cre3-callout--info   { background: var(--t3-cyan-dim);   border: 1px solid var(--t3-cyan-border); }
   .cre3-callout--purple { background: var(--t3-purple-dim); border: 1px solid var(--t3-purple-border); }
   
   /* ─── Card grid ──────────────────────────────────────────────────── */
   .cre3-card-grid {
     display:               grid;
     grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
     gap:                   14px;
     margin:                20px 0;
   }
   
   .cre3-card {
     background:    var(--t3-surface);
     border:        1px solid var(--t3-border-light);
     border-radius: var(--t3-radius-md);
     padding:       16px 18px;
     transition:    border-color 0.18s, box-shadow 0.18s, transform 0.18s;
     box-shadow:    0 1px 4px rgba(0,0,0,0.04);
   }
   .cre3-card:hover {
     border-color: var(--t3-accent);
     box-shadow:   0 4px 14px rgba(40,167,69,0.10);
     transform:    translateY(-2px);
   }
   .cre3-card-icon  { font-size: 22px; margin-bottom: 8px; }
   .cre3-card h4    { font-size: 14px; font-weight: 600; color: var(--t3-text-mid); margin-bottom: 6px; font-family: var(--t3-font-ui); }
   .cre3-card p     { font-size: 13px; color: var(--t3-text-muted); margin: 0; line-height: 1.5; }
   
   /* ─── Comparison cards (2-up) ────────────────────────────────────── */
   .cre3-two-col {
     display:               grid;
     grid-template-columns: 1fr 1fr;
     gap:                   16px;
     margin:                20px 0;
   }
   
   @media (max-width: 720px) {
     .cre3-two-col { grid-template-columns: 1fr; }
   }
   
   /* ─── Steps list ─────────────────────────────────────────────────── */
   .cre3-steps { margin: 20px 0; }
   
   .cre3-step {
     display:     flex;
     gap:         16px;
     margin-bottom: 20px;
     align-items: flex-start;
   }
   
   .cre3-step-num {
     min-width:       32px;
     height:          32px;
     background:      var(--t3-accent);
     color:           #fff;
     border-radius:   50%;
     display:         flex;
     align-items:     center;
     justify-content: center;
     font-family:     var(--t3-font-mono);
     font-weight:     600;
     font-size:       13px;
     margin-top:      2px;
     flex-shrink:     0;
     box-shadow:      0 2px 8px var(--t3-accent-glow);
   }
   
   .cre3-step-content { flex: 1 1; }
   .cre3-step-content h4 { font-size: 14px; font-weight: 600; color: var(--t3-text-mid); margin-bottom: 6px; font-family: var(--t3-font-ui); }
   .cre3-step-content p  { font-size: 13.5px; color: var(--t3-text-muted); margin: 0 0 8px; }
   
   /* ─── Example box ────────────────────────────────────────────────── */
   .cre3-example-box {
     background:    var(--t3-surface);
     border:        1px solid var(--t3-border-light);
     border-top:    3px solid var(--t3-accent);
     border-radius: var(--t3-radius-md);
     padding:       20px 24px;
     margin:        20px 0;
     box-shadow:    0 2px 10px rgba(0,0,0,0.04);
   }
   
   .cre3-example-tag {
     font-family:    var(--t3-font-mono);
     font-size:      10px;
     text-transform: uppercase;
     letter-spacing: 2px;
     color:          var(--t3-accent);
     margin-bottom:  8px;
   }
   
   .cre3-example-box h4 { font-size: 15px; font-weight: 600; color: var(--t3-text-mid); margin-bottom: 10px; font-family: var(--t3-font-ui); }
   .cre3-example-box p  { color: var(--t3-text-muted); font-size: 13.5px; margin-bottom: 10px; }
   
   /* ─── Inline code ────────────────────────────────────────────────── */
   .cre3-inline-code {
     font-family:   var(--t3-font-mono);
     font-size:     0.88em;
     background:    var(--t3-code-bg);
     color:         var(--t3-blue);
     padding:       2px 5px;
     border-radius: var(--t3-radius-sm);
     border:        1px solid var(--t3-border-light);
   }
   
   /* ─── Summary table ──────────────────────────────────────────────── */
   .cre3-table {
     width:           100%;
     border-collapse: collapse;
     margin:          20px 0;
     font-size:       13px;
     background:      var(--t3-surface);
     border-radius:   var(--t3-radius-md);
     overflow:        hidden;
     border:          1px solid var(--t3-border-light);
   }
   
   .cre3-table thead { background: var(--t3-panel); }
   .cre3-table th    { padding: 10px 14px; text-align: left; font-family: var(--t3-font-mono); font-size: 10px; text-transform: uppercase; letter-spacing: 1.5px; color: var(--t3-text-muted); border-bottom: 1px solid var(--t3-border); font-weight: 500; }
   .cre3-table td    { padding: 10px 14px; border-bottom: 1px solid var(--t3-border-light); color: var(--t3-text-muted); vertical-align: top; }
   .cre3-table tr:last-child td { border-bottom: none; }
   .cre3-table tr:hover td { background: rgba(40,167,69,0.03); }
   .cre3-table .katex { font-size: 1.0em; }
   
   /* ─── Activation energy highlight band ──────────────────────────── */
   .cre3-energy-band {
     display:        flex;
     gap:            12px;
     align-items:    stretch;
     margin:         18px 0;
     flex-wrap:      wrap;
   }
   
   .cre3-energy-block {
     flex:          1 1;
     min-width:     160px;
     background:    var(--t3-surface);
     border:        1px solid var(--t3-border-light);
     border-radius: var(--t3-radius-md);
     padding:       14px 16px;
     text-align:    center;
   }
   
   .cre3-energy-block .val {
     font-family: var(--t3-font-mono);
     font-size:   22px;
     font-weight: 600;
     color:       var(--t3-blue);
     display:     block;
     margin-bottom: 4px;
   }
   
   .cre3-energy-block .desc {
     font-size: 12px;
     color:     var(--t3-text-dim);
   }
   
   /* ─── Arrhenius highlight card ───────────────────────────────────── */
   .cre3-arrh-card {
     background:     linear-gradient(135deg, rgba(40,167,69,0.06) 0%, rgba(74,144,217,0.06) 100%);
     border:         1px solid var(--t3-green-border);
     border-radius:  var(--t3-radius-lg);
     padding:        28px 32px;
     margin:         24px 0;
     text-align:     center;
   }
   
   .cre3-arrh-card .cre3-eq-main { font-size: 18px; }
   .cre3-arrh-card .katex        { font-size: 1.35em; }
   
   .cre3-arrh-card p {
     margin-top: 12px;
     font-size:  13px;
     color:      var(--t3-text-dim);
   }
   
   /* ─── Parameter list ─────────────────────────────────────────────── */
   .cre3-param-list {
     display:    flex;
     flex-wrap:  wrap;
     gap:        12px;
     margin:     16px 0;
   }
   
   .cre3-param {
     flex:          1 1;
     min-width:     150px;
     background:    var(--t3-surface);
     border:        1px solid var(--t3-border-light);
     border-radius: var(--t3-radius-md);
     padding:       12px 16px;
   }
   
   .cre3-param-sym {
     font-family: var(--t3-font-mono);
     font-size:   18px;
     color:       var(--t3-blue);
     font-weight: 600;
     margin-bottom: 4px;
   }
   
   .cre3-param-name {
     font-size:  13px;
     font-weight: 600;
     color:      var(--t3-text-mid);
     margin-bottom: 2px;
   }
   
   .cre3-param-unit {
     font-family: var(--t3-font-mono);
     font-size:   11px;
     color:       var(--t3-text-dim);
   }
   
   /* ─── Footer ─────────────────────────────────────────────────────── */
   .cre3-footer {
     border-top:  1px solid var(--t3-border-light);
     padding-top: 24px;
     margin-top:  40px;
     color:       var(--t3-text-dim);
     font-family: var(--t3-font-mono);
     font-size:   11px;
   }
   
   /* ─── Animation ──────────────────────────────────────────────────── */
   @keyframes fadeIn3 {
     from { opacity: 0; transform: translateY(4px); }
     to   { opacity: 1; transform: translateY(0);   }
   }
   
   /* ─── Responsive ─────────────────────────────────────────────────── */
   @media (max-width: 1200px) {
     .cre3-main-inner { padding: 36px 36px 60px; }
   }
   
   @media (max-width: 900px) {
     .cre3-sidebar { display: none !important; }
     .cre3-main-inner {
       padding:   24px 20px 60px;
       max-width: 100%;
     }
     .cre3-toc-grid { grid-template-columns: 1fr; }
   }
   
   @media (max-width: 600px) {
     .cre3-card-grid { grid-template-columns: 1fr; }
     .cre3-hero h1   { font-size: 28px; }
     .cre3-two-col   { grid-template-columns: 1fr; }
   }
   `, "",{"version":3,"sources":["webpack://./src/styles/Tutorial3.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;GAK9D,uEAAuE;GACvE;KACE,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;;KAE7B,6BAA6B;KAC7B,6CAA6C;KAC7C,6CAA6C;KAC7C,6BAA6B;;KAE7B,6BAA6B;KAC7B,6CAA6C;KAC7C,6CAA6C;KAC7C,6BAA6B;KAC7B,8CAA8C;KAC9C,8CAA8C;KAC9C,6BAA6B;KAC7B,8CAA8C;KAC9C,8CAA8C;KAC9C,6CAA6C;KAC7C,6CAA6C;KAC7C,6BAA6B;KAC7B,6CAA6C;KAC7C,6CAA6C;KAC7C,6BAA6B;KAC7B,8CAA8C;KAC9C,8CAA8C;;KAE9C,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;;KAE7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;;KAE7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;;KAE7B,wDAAwD;KACxD,8DAA8D;KAC9D,oCAAoC;KACpC,kDAAkD;;KAElD,mBAAmB;KACnB,oBAAoB;KACpB,oBAAoB;KACpB,oBAAoB;KACpB,oBAAoB;KACpB,oBAAoB;;KAEpB,mBAAmB;KACnB,mBAAmB;KACnB,oBAAoB;;KAEpB,qBAAqB;GACvB;;GAEA,uEAAuE;GACvE;;;KAGE,sBAAsB;KACtB,SAAS;KACT,UAAU;GACZ;;GAEA,uEAAuE;GACvE,6BAA6B,UAAU,EAAE,WAAW,EAAE;GACtD,6BAA6B,uBAAuB,EAAE;GACtD,6BAA6B,4BAA4B,EAAE,kBAAkB,EAAE;GAC/E,kCAAkC,gCAAgC,EAAE;;GAEpE;;mEAEgE;GAChE;KACE,8BAA8B;KAC9B,yBAAyB;KACzB,2BAA2B;KAC3B,iBAAiB;KACjB,iBAAiB;KACjB,iBAAiB;KACjB,iBAAiB;KACjB,gBAAgB;KAChB,mBAAmB;GACrB;;GAEA;;mEAEgE;GAChE;KACE,oBAAoB;KACpB,mCAAmC;KACnC,mCAAmC;KACnC,oCAAoC;KACpC,0CAA0C;KAC1C,oBAAoB;KACpB,oBAAoB;KACpB,oBAAoB;KACpB,oBAAoB;KACpB,iBAAiB;KACjB,wBAAwB;GAC1B;;GAEA;KACE,gBAAgB,cAAc,EAAE;GAClC;;GAEA;KACE,uCAAuC;KACvC,6BAA6B;KAC7B,yCAAyC;KACzC,qBAAqB;KACrB,gBAAgB;KAChB,iBAAiB;GACnB;;GAEA;KACE,mCAAmC;KACnC,oBAAoB;KACpB,yBAAyB;KACzB,mBAAmB;KACnB,gCAAgC;KAChC,mBAAmB;KACnB,mBAAmB;GACrB;;GAEA;KACE,eAAe;KACf,+BAA+B;GACjC;;GAEA;KACE,+BAA+B;KAC/B,mCAAmC;KACnC,oBAAoB;KACpB,yBAAyB;KACzB,mBAAmB;KACnB,+BAA+B;KAC/B,mBAAmB;KACnB,mBAAmB;GACrB;;GAEA;KACE,mBAAmB;KACnB,+BAA+B;KAC/B,kCAAkC;KAClC,qBAAqB;KACrB,mCAAmC;KACnC,uBAAuB;KACvB,iBAAiB;KACjB,qBAAqB;GACvB;GACA;KACE,iCAAiC;KACjC,0CAA0C;KAC1C,mCAAmC;GACrC;GACA;KACE,kBAAkB;KAClB,kBAAkB;KAClB,gCAAgC;GAClC;;GAEA;;mEAEgE;GAChE;KACE,eAAa;KACb,gBAAgB;KAChB,kBAAkB;KAClB,aAAa;KACb,6BAA6B;GAC/B;;GAEA;KACE,eAAe;KACf,uBAAuB;GACzB;;GAEA,uEAAuE;GACvE;KACE,mCAAmC;KACnC,oBAAoB;KACpB,gDAAgD;GAClD;;GAEA;KACE,mCAAmC;KACnC,oBAAoB;KACpB,yBAAyB;KACzB,mBAAmB;KACnB,+BAA+B;KAC/B,oBAAoB;GACtB;;GAEA;KACE,mCAAmC;KACnC,mBAAmB;KACnB,kBAAkB;KAClB,kBAAkB;KAClB,mBAAmB;KACnB,6BAA6B;GAC/B;;GAEA;KACE,+BAA+B;KAC/B,eAAe;KACf,gBAAgB;KAChB,gBAAgB;GAClB;;GAEA;KACE,gBAAgB;KAChB,gBAAgB;KAChB,gBAAgB;KAChB,gBAAgB;GAClB;;GAEA;KACE,gCAAgC;KAChC,iBAAiB;KACjB,+BAA+B;KAC/B,iBAAiB;KACjB,mBAAmB;KACnB,gBAAgB;GAClB;;GAEA;KACE,kBAAkB;KAClB,kBAAkB;KAClB,kBAAkB;KAClB,+BAA+B;KAC/B,2BAA2B;GAC7B;;GAEA,uEAAuE;GACvE;KACE,gCAAgC;KAChC,+CAA+C;KAC/C,kCAAkC;KAClC,wBAAwB;KACxB,kCAAkC;GACpC;;GAEA;KACE,mCAAmC;KACnC,oBAAoB;KACpB,yBAAyB;KACzB,mBAAmB;KACnB,kCAAkC;KAClC,oBAAoB;GACtB;;GAEA;KACE,2BAA2B;KAC3B,4DAA4D;KAC5D,+BAA+B;GACjC;;GAEA;KACE,oBAAoB;KACpB,8BAA8B;KAC9B,qBAAqB;KACrB,uBAAuB;KACvB,mCAAmC;KACnC,gCAAgC;GAClC;GACA,uBAAuB,8BAA8B,EAAE;;GAEvD,uEAAuE;GACvE;KACE,4BAA4B;KAC5B,mCAAmC;KACnC,oBAAoB;KACpB,yBAAyB;KACzB,mBAAmB;KACnB,wBAAwB;KACxB,oBAAoB;KACpB,oBAAoB;KACpB,mBAAmB;GACrB;GACA,wBAAwB,+BAA+B,GAAG,sBAAsB,GAAG,wCAAwC,EAAE;GAC7H,wBAAwB,8BAA8B,IAAI,qBAAqB,IAAI,uCAAuC,EAAE;GAC5H,wBAAwB,gCAAgC,EAAE,uBAAuB,EAAE,yCAAyC,EAAE;GAC9H,wBAAwB,+BAA+B,GAAG,uBAAuB,EAAE,wCAAwC,EAAE;GAC7H,wBAAwB,8BAA8B,IAAI,qBAAqB,IAAI,uCAAuC,EAAE;;GAE5H,uEAAuE;GACvE;KACE,mCAAmC;KACnC,uBAAuB;GACzB;;GAEA;KACE,mCAAmC;KACnC,oBAAoB;KACpB,yBAAyB;KACzB,qBAAqB;KACrB,gCAAgC;KAChC,mBAAmB;GACrB;;GAEA;KACE,mCAAmC;KACnC,mBAAmB;KACnB,kBAAkB;KAClB,6BAA6B;KAC7B,kBAAkB;KAClB,kBAAkB;GACpB;;GAEA;KACE,mBAAmB;KACnB,kBAAkB;KAClB,+BAA+B;KAC/B,mBAAmB;KACnB,kBAAkB;GACpB;;GAEA;KACE,kCAAkC;KAClC,kBAAkB;KAClB,iBAAiB;KACjB,gCAAgC;KAChC,yBAAyB;GAC3B;;GAEA;KACE,+BAA+B;KAC/B,kBAAkB;KAClB,iBAAiB;KACjB,gCAAgC;KAChC,wBAAwB;GAC1B;;GAEA;KACE,mBAAmB;KACnB,mCAAmC;KACnC,mBAAmB;GACrB;;GAEA;;KAEE,mBAAmB;KACnB,mBAAmB;KACnB,mCAAmC;GACrC;;GAEA,mBAAmB,kBAAkB,EAAE;;GAEvC,uEAAuE;GACvE;KACE,8BAA8B;KAC9B,+CAA+C;KAC/C,wCAAwC;KACxC,kCAAkC;KAClC,wBAAwB;KACxB,qBAAqB;KACrB,mBAAmB;GACrB;;GAEA,uBAAuB,iCAAiC,IAAI,8BAA8B,EAAE;GAC5F,uBAAuB,mCAAmC,EAAE,+BAA+B,EAAE;GAC7F,uBAAuB,mCAAmC,EAAE,gCAAgC,EAAE;GAC9F,uBAAuB,gCAAgC,KAAK,6BAA6B,EAAE;;GAE3F;KACE,oBAAoB;KACpB,mCAAmC;KACnC,yBAAyB;KACzB,mBAAmB;KACnB,kCAAkC;KAClC,oBAAoB;GACtB;;GAEA;KACE,gCAAgC;KAChC,iBAAiB;KACjB,2BAA2B;KAC3B,cAAc;GAChB;;GAEA,+DAA+D;GAC/D,uBAAuB,iBAAiB,EAAE;GAC1C,uBAAuB,gBAAgB,EAAE;;GAEzC;KACE,mBAAmB;KACnB,+BAA+B;KAC/B,iBAAiB;KACjB,gBAAgB;GAClB;;GAEA,sEAAsE;GACtE;KACE,qBAAqB;KACrB,yBAAyB;KACzB,uBAAuB;KACvB,uBAAuB;KACvB,kCAAkC;KAClC,oCAAoC;KACpC,uBAAuB;KACvB,iDAAiD;GACnD;;GAEA;KACE,2BAA2B;GAC7B;;GAEA;KACE,yBAAyB;KACzB,oBAAoB;KACpB,mCAAmC;KACnC,oBAAoB;KACpB,yBAAyB;KACzB,qBAAqB;KACrB,oCAAoC;KACpC,0CAA0C;KAC1C,mBAAmB;GACrB;;GAEA;KACE,wBAAwB;KACxB,+CAA+C;KAC/C,mCAAmC;KACnC,sBAAsB;GACxB;;GAEA,uCAAuC,mBAAmB,EAAE;GAC5D,kCAAkC,gCAAgC,EAAE;;GAEpE,6BAA6B,iBAAiB,EAAE;;GAEhD,wBAAwB;GACxB;KACE,4BAA4B;KAC5B,mCAAmC;KACnC,oBAAoB;KACpB,yBAAyB;KACzB,qBAAqB;KACrB,uBAAuB;KACvB,oBAAoB;KACpB,mBAAmB;GACrB;GACA,oBAAoB,gCAAgC,GAAG,sBAAsB,EAAE;GAC/E,oBAAoB,gCAAgC,GAAG,qBAAqB,EAAE;GAC9E,oBAAoB,8BAA8B,KAAK,oBAAoB,EAAE;GAC7E,oBAAoB,+BAA+B,IAAI,oBAAoB,EAAE;;GAE7E,uEAAuE;GACvE;KACE,kCAAkC;KAClC,wBAAwB;KACxB,qBAAqB;KACrB,mBAAmB;KACnB,mBAAmB;GACrB;GACA,mBAAmB,2BAA2B,EAAE,SAAS,EAAE;GAC3D,wBAAwB,8BAA8B,IAAI,uCAAuC,EAAE;GACnG,wBAAwB,+BAA+B,GAAG,wCAAwC,EAAE;GACpG,wBAAwB,+BAA+B,GAAG,wCAAwC,EAAE;GACpG,wBAAwB,8BAA8B,IAAI,uCAAuC,EAAE;GACnG,wBAAwB,gCAAgC,EAAE,yCAAyC,EAAE;;GAErG,uEAAuE;GACvE;KACE,2BAA2B;KAC3B,4DAA4D;KAC5D,2BAA2B;KAC3B,6BAA6B;GAC/B;;GAEA;KACE,gCAAgC;KAChC,+CAA+C;KAC/C,kCAAkC;KAClC,wBAAwB;KACxB,oEAAoE;KACpE,yCAAyC;GAC3C;GACA;KACE,8BAA8B;KAC9B,6CAA6C;KAC7C,8BAA8B;GAChC;GACA,mBAAmB,eAAe,EAAE,kBAAkB,EAAE;GACxD,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,8BAA8B,EAAE;GACrI,mBAAmB,eAAe,EAAE,2BAA2B,EAAE,SAAS,EAAE,gBAAgB,EAAE;;GAE9F,uEAAuE;GACvE;KACE,2BAA2B;KAC3B,8BAA8B;KAC9B,2BAA2B;KAC3B,6BAA6B;GAC/B;;GAEA;KACE,gBAAgB,0BAA0B,EAAE;GAC9C;;GAEA,uEAAuE;GACvE,cAAc,cAAc,EAAE;;GAE9B;KACE,iBAAiB;KACjB,iBAAiB;KACjB,mBAAmB;KACnB,uBAAuB;GACzB;;GAEA;KACE,qBAAqB;KACrB,qBAAqB;KACrB,iCAAiC;KACjC,qBAAqB;KACrB,oBAAoB;KACpB,qBAAqB;KACrB,uBAAuB;KACvB,uBAAuB;KACvB,oCAAoC;KACpC,oBAAoB;KACpB,qBAAqB;KACrB,oBAAoB;KACpB,kBAAkB;KAClB,gDAAgD;GAClD;;GAEA,qBAAqB,SAAO,EAAE;GAC9B,wBAAwB,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,8BAA8B,EAAE;GAC1I,wBAAwB,iBAAiB,EAAE,2BAA2B,EAAE,eAAe,EAAE;;GAEzF,uEAAuE;GACvE;KACE,gCAAgC;KAChC,+CAA+C;KAC/C,yCAAyC;KACzC,kCAAkC;KAClC,wBAAwB;KACxB,qBAAqB;KACrB,0CAA0C;GAC5C;;GAEA;KACE,mCAAmC;KACnC,oBAAoB;KACpB,yBAAyB;KACzB,mBAAmB;KACnB,gCAAgC;KAChC,mBAAmB;GACrB;;GAEA,uBAAuB,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,8BAA8B,EAAE;GAC1I,uBAAuB,2BAA2B,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;;GAE5F,uEAAuE;GACvE;KACE,kCAAkC;KAClC,qBAAqB;KACrB,gCAAgC;KAChC,6BAA6B;KAC7B,sBAAsB;KACtB,kCAAkC;KAClC,+CAA+C;GACjD;;GAEA,uEAAuE;GACvE;KACE,qBAAqB;KACrB,yBAAyB;KACzB,uBAAuB;KACvB,qBAAqB;KACrB,kCAAkC;KAClC,oCAAoC;KACpC,uBAAuB;KACvB,iDAAiD;GACnD;;GAEA,oBAAoB,2BAA2B,EAAE;GACjD,oBAAoB,kBAAkB,EAAE,gBAAgB,EAAE,gCAAgC,EAAE,eAAe,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,2BAA2B,EAAE,yCAAyC,EAAE,gBAAgB,EAAE;GACzP,oBAAoB,kBAAkB,EAAE,+CAA+C,EAAE,2BAA2B,EAAE,mBAAmB,EAAE;GAC3I,+BAA+B,mBAAmB,EAAE;GACpD,0BAA0B,gCAAgC,EAAE;GAC5D,qBAAqB,gBAAgB,EAAE;;GAEvC,sEAAsE;GACtE;KACE,oBAAoB;KACpB,oBAAoB;KACpB,uBAAuB;KACvB,sBAAsB;KACtB,oBAAoB;GACtB;;GAEA;KACE,kBAAgB;KAChB,oBAAoB;KACpB,gCAAgC;KAChC,+CAA+C;KAC/C,kCAAkC;KAClC,wBAAwB;KACxB,qBAAqB;GACvB;;GAEA;KACE,gCAAgC;KAChC,iBAAiB;KACjB,gBAAgB;KAChB,2BAA2B;KAC3B,kBAAkB;KAClB,kBAAkB;GACpB;;GAEA;KACE,eAAe;KACf,6BAA6B;GAC/B;;GAEA,uEAAuE;GACvE;KACE,4FAA4F;KAC5F,gDAAgD;KAChD,mCAAmC;KACnC,yBAAyB;KACzB,sBAAsB;KACtB,sBAAsB;GACxB;;GAEA,gCAAgC,eAAe,EAAE;GACjD,gCAAgC,iBAAiB,EAAE;;GAEnD;KACE,gBAAgB;KAChB,gBAAgB;KAChB,8BAA8B;GAChC;;GAEA,uEAAuE;GACvE;KACE,gBAAgB;KAChB,gBAAgB;KAChB,gBAAgB;KAChB,kBAAkB;GACpB;;GAEA;KACE,kBAAgB;KAChB,oBAAoB;KACpB,gCAAgC;KAChC,+CAA+C;KAC/C,kCAAkC;KAClC,wBAAwB;GAC1B;;GAEA;KACE,gCAAgC;KAChC,iBAAiB;KACjB,2BAA2B;KAC3B,gBAAgB;KAChB,kBAAkB;GACpB;;GAEA;KACE,gBAAgB;KAChB,gBAAgB;KAChB,8BAA8B;KAC9B,kBAAkB;GACpB;;GAEA;KACE,gCAAgC;KAChC,iBAAiB;KACjB,+BAA+B;GACjC;;GAEA,uEAAuE;GACvE;KACE,6CAA6C;KAC7C,iBAAiB;KACjB,iBAAiB;KACjB,+BAA+B;KAC/B,gCAAgC;KAChC,iBAAiB;GACnB;;GAEA,uEAAuE;GACvE;KACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;KAC/C,OAAO,UAAU,EAAE,wBAAwB,IAAI;GACjD;;GAEA,uEAAuE;GACvE;KACE,mBAAmB,uBAAuB,EAAE;GAC9C;;GAEA;KACE,gBAAgB,wBAAwB,EAAE;KAC1C;OACE,yBAAyB;OACzB,eAAe;KACjB;KACA,iBAAiB,0BAA0B,EAAE;GAC/C;;GAEA;KACE,kBAAkB,0BAA0B,EAAE;KAC9C,kBAAkB,eAAe,EAAE;KACnC,kBAAkB,0BAA0B,EAAE;GAChD","sourcesContent":["/* ============================================================\n   Tutorial3.css  —  KinetiQ CRE Course Notes · Lecture 3\n   Same design system as Tutorial1.css.\n   Scoped under .cre3- prefix to avoid collisions.\n   ============================================================ */\n\n   @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&family=Syne:wght@400;700;800&family=DM+Mono:wght@400;500&family=Source+Serif+4:ital,wght@0,400;0,600;0,700;1,400&display=swap');\n   @import url('https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/katex.min.css');\n   \n   /* ─── Design tokens ──────────────────────────────────────────────── */\n   :root {\n     --t3-bg:              #e4ecf3;\n     --t3-surface:         #ffffff;\n     --t3-panel:           #f5f1ed;\n     --t3-card:            #ffffff;\n     --t3-sidebar-bg:      #f0ebe4;\n     --t3-sidebar-header:  #e8e2da;\n     --t3-code-bg:         #fdf7ef;\n     --t3-eq-bg:           #faf5ee;\n   \n     --t3-accent:          #28a745;\n     --t3-accent-dim:      rgba(40, 167, 69, 0.10);\n     --t3-accent-glow:     rgba(40, 167, 69, 0.22);\n     --t3-accent-hover:    #1f8836;\n   \n     --t3-amber:           #e89c00;\n     --t3-amber-dim:       rgba(232, 156, 0, 0.10);\n     --t3-amber-border:    rgba(232, 156, 0, 0.28);\n     --t3-cyan:            #0ab5e2;\n     --t3-cyan-dim:        rgba(10, 181, 226, 0.10);\n     --t3-cyan-border:     rgba(10, 181, 226, 0.25);\n     --t3-blue:            #4a90d9;\n     --t3-blue-dim:        rgba(74, 144, 217, 0.10);\n     --t3-blue-border:     rgba(74, 144, 217, 0.28);\n     --t3-green-dim:       rgba(40, 167, 69, 0.08);\n     --t3-green-border:    rgba(40, 167, 69, 0.25);\n     --t3-red:             #c0392b;\n     --t3-red-dim:         rgba(192, 57, 43, 0.08);\n     --t3-red-border:      rgba(192, 57, 43, 0.25);\n     --t3-purple:          #8e44ad;\n     --t3-purple-dim:      rgba(142, 68, 173, 0.08);\n     --t3-purple-border:   rgba(142, 68, 173, 0.25);\n   \n     --t3-batch:           #e89c00;\n     --t3-cstr:            #e0603a;\n     --t3-pfr:             #4a90d9;\n     --t3-pbr:             #28a745;\n   \n     --t3-border:          #cfc4b8;\n     --t3-border-light:    #e5dbd0;\n     --t3-border-mid:      #bbb0a4;\n   \n     --t3-text:            #1a1209;\n     --t3-text-muted:      #3a2f28;\n     --t3-text-mid:        #4a3f38;\n     --t3-text-dim:        #6a5f58;\n     --t3-text-sub:        #8a7e76;\n   \n     --t3-font-mono:   'DM Mono', 'JetBrains Mono', monospace;\n     --t3-font-ui:     'DM Sans', 'Segoe UI', system-ui, sans-serif;\n     --t3-font-brand:  'Syne', sans-serif;\n     --t3-font-serif:  'Source Serif 4', Georgia, serif;\n   \n     --t3-space-xs:  6px;\n     --t3-space-sm:  10px;\n     --t3-space-md:  16px;\n     --t3-space-lg:  24px;\n     --t3-space-xl:  40px;\n     --t3-space-2xl: 56px;\n   \n     --t3-radius-sm: 5px;\n     --t3-radius-md: 9px;\n     --t3-radius-lg: 13px;\n   \n     --t3-sidebar-w: 268px;\n   }\n   \n   /* ─── Reset ──────────────────────────────────────────────────────── */\n   *,\n   *::before,\n   *::after {\n     box-sizing: border-box;\n     margin: 0;\n     padding: 0;\n   }\n   \n   /* ─── Scrollbar ──────────────────────────────────────────────────── */\n   ::-webkit-scrollbar        { width: 5px; height: 5px; }\n   ::-webkit-scrollbar-track  { background: transparent; }\n   ::-webkit-scrollbar-thumb  { background: var(--t3-border); border-radius: 3px; }\n   ::-webkit-scrollbar-thumb:hover { background: var(--t3-border-mid); }\n   \n   /* ══════════════════════════════════════════════════════════════\n      CONTAINER\n   ══════════════════════════════════════════════════════════════ */\n   .cre3-container {\n     font-family: var(--t3-font-ui);\n     background:  var(--t3-bg);\n     color:       var(--t3-text);\n     display:     flex;\n     height:      100%;\n     width:       100%;\n     font-size:   15px;\n     line-height: 1.7;\n     overflow:    hidden;\n   }\n   \n   /* ══════════════════════════════════════════════════════════════\n      SIDEBAR\n   ══════════════════════════════════════════════════════════════ */\n   .cre3-sidebar {\n     display:        none;\n     width:          var(--t3-sidebar-w);\n     min-width:      var(--t3-sidebar-w);\n     background:     var(--t3-sidebar-bg);\n     border-right:   1px solid var(--t3-border);\n     height:         100%;\n     overflow-y:     auto;\n     padding-bottom: 40px;\n     font-size:      13px;\n     flex-shrink:    0;\n     position:       relative;\n   }\n   \n   @media (min-width: 1400px) {\n     .cre3-sidebar { display: block; }\n   }\n   \n   .cre3-sidebar-header {\n     background:    var(--t3-sidebar-header);\n     padding:       20px 18px 16px;\n     border-bottom: 1px solid var(--t3-border);\n     position:      sticky;\n     top:           0;\n     z-index:       10;\n   }\n   \n   .cre3-sidebar-header h1 {\n     font-family:    var(--t3-font-mono);\n     font-size:      11px;\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     color:          var(--t3-accent);\n     margin-bottom:  4px;\n     font-weight:    500;\n   }\n   \n   .cre3-sidebar-header p {\n     font-size: 12px;\n     color:     var(--t3-text-muted);\n   }\n   \n   .cre3-nav-section {\n     padding:        14px 0 4px 18px;\n     font-family:    var(--t3-font-mono);\n     font-size:      10px;\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     color:          var(--t3-amber);\n     margin-top:     8px;\n     font-weight:    500;\n   }\n   \n   .cre3-nav-item {\n     display:      block;\n     padding:      7px 18px 7px 28px;\n     color:        var(--t3-text-muted);\n     text-decoration: none;\n     border-left:  3px solid transparent;\n     transition:   all 0.15s;\n     line-height:  1.4;\n     cursor:       pointer;\n   }\n   .cre3-nav-item:hover {\n     color:             var(--t3-text);\n     background:        rgba(40, 167, 69, 0.06);\n     border-left-color: var(--t3-accent);\n   }\n   .cre3-nav-item--sub {\n     padding-left: 40px;\n     font-size:    12px;\n     color:        var(--t3-text-dim);\n   }\n   \n   /* ══════════════════════════════════════════════════════════════\n      MAIN CONTENT\n   ══════════════════════════════════════════════════════════════ */\n   .cre3-main {\n     flex:       1;\n     overflow-y: auto;\n     overflow-x: hidden;\n     min-width:  0;\n     animation:  fadeIn3 0.3s ease;\n   }\n   \n   .cre3-main-inner {\n     margin:  0 auto;\n     padding: 48px 56px 80px;\n   }\n   \n   /* ─── Hero ───────────────────────────────────────────────────────── */\n   .cre3-hero {\n     margin-bottom:  var(--t3-space-2xl);\n     padding-bottom: 32px;\n     border-bottom:  1px solid var(--t3-border-light);\n   }\n   \n   .cre3-hero-tag {\n     font-family:    var(--t3-font-mono);\n     font-size:      11px;\n     text-transform: uppercase;\n     letter-spacing: 3px;\n     color:          var(--t3-amber);\n     margin-bottom:  12px;\n   }\n   \n   .cre3-hero h1 {\n     font-family:   var(--t3-font-serif);\n     font-size:     38px;\n     font-weight:   700;\n     line-height:   1.2;\n     margin-bottom: 12px;\n     color:         var(--t3-text);\n   }\n   \n   .cre3-hero-desc {\n     color:     var(--t3-text-muted);\n     font-size: 16px;\n     max-width: 600px;\n     line-height: 1.6;\n   }\n   \n   .cre3-hero-meta {\n     display:    flex;\n     gap:        24px;\n     margin-top: 20px;\n     flex-wrap:  wrap;\n   }\n   \n   .cre3-meta-item {\n     font-family: var(--t3-font-mono);\n     font-size:   11px;\n     color:       var(--t3-text-dim);\n     display:     flex;\n     align-items: center;\n     gap:         6px;\n   }\n   \n   .cre3-meta-dot {\n     width:         6px;\n     height:        6px;\n     border-radius: 50%;\n     background:    var(--t3-accent);\n     display:       inline-block;\n   }\n   \n   /* ─── TOC ────────────────────────────────────────────────────────── */\n   .cre3-toc-box {\n     background:    var(--t3-surface);\n     border:        1px solid var(--t3-border-light);\n     border-radius: var(--t3-radius-lg);\n     padding:       24px 28px;\n     margin-bottom: var(--t3-space-2xl);\n   }\n   \n   .cre3-toc-box h3 {\n     font-family:    var(--t3-font-mono);\n     font-size:      11px;\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     color:          var(--t3-text-sub);\n     margin-bottom:  14px;\n   }\n   \n   .cre3-toc-grid {\n     display:               grid;\n     grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n     gap:                   6px 12px;\n   }\n   \n   .cre3-toc-link {\n     font-size:      13px;\n     color:          var(--t3-blue);\n     text-decoration: none;\n     padding:        4px 8px;\n     border-radius:  var(--t3-radius-sm);\n     transition:     background 0.15s;\n   }\n   .cre3-toc-link:hover { background: var(--t3-blue-dim); }\n   \n   /* ─── Lecture badge ──────────────────────────────────────────────── */\n   .cre3-lec-badge {\n     display:        inline-block;\n     font-family:    var(--t3-font-mono);\n     font-size:      10px;\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     padding:        3px 10px;\n     border-radius:  20px;\n     margin-bottom:  10px;\n     font-weight:    500;\n   }\n   .cre3-lec-badge--lec1 { background: var(--t3-amber-dim);  color: var(--t3-amber);  border: 1px solid var(--t3-amber-border); }\n   .cre3-lec-badge--lec3 { background: var(--t3-blue-dim);   color: var(--t3-blue);   border: 1px solid var(--t3-blue-border); }\n   .cre3-lec-badge--rate { background: var(--t3-purple-dim); color: var(--t3-purple); border: 1px solid var(--t3-purple-border); }\n   .cre3-lec-badge--arrh { background: var(--t3-green-dim);  color: var(--t3-accent); border: 1px solid var(--t3-green-border); }\n   .cre3-lec-badge--ref  { background: var(--t3-cyan-dim);   color: var(--t3-cyan);   border: 1px solid var(--t3-cyan-border); }\n   \n   /* ─── Section ────────────────────────────────────────────────────── */\n   .cre3-section {\n     margin-bottom:  var(--t3-space-2xl);\n     scroll-margin-top: 20px;\n   }\n   \n   .cre3-section-label {\n     font-family:    var(--t3-font-mono);\n     font-size:      10px;\n     text-transform: uppercase;\n     letter-spacing: 2.5px;\n     color:          var(--t3-accent);\n     margin-bottom:  6px;\n   }\n   \n   .cre3-section h2 {\n     font-family:   var(--t3-font-serif);\n     font-size:     26px;\n     font-weight:   700;\n     color:         var(--t3-text);\n     margin-bottom: 6px;\n     line-height:   1.3;\n   }\n   \n   .cre3-section-divider {\n     width:         40px;\n     height:        3px;\n     background:    var(--t3-accent);\n     margin-bottom: 22px;\n     border-radius: 2px;\n   }\n   \n   .cre3-section h3 {\n     font-family:  var(--t3-font-serif);\n     font-size:    18px;\n     font-weight:  600;\n     color:        var(--t3-text-mid);\n     margin:       28px 0 10px;\n   }\n   \n   .cre3-section h4 {\n     font-family:  var(--t3-font-ui);\n     font-size:    15px;\n     font-weight:  600;\n     color:        var(--t3-text-mid);\n     margin:       18px 0 8px;\n   }\n   \n   .cre3-section p {\n     margin-bottom: 14px;\n     color:         var(--t3-text-muted);\n     line-height:   1.75;\n   }\n   \n   .cre3-section ul,\n   .cre3-section ol {\n     padding-left:  20px;\n     margin-bottom: 14px;\n     color:         var(--t3-text-muted);\n   }\n   \n   .cre3-section li { margin-bottom: 6px; }\n   \n   /* ─── Equation box ───────────────────────────────────────────────── */\n   .cre3-eq-box {\n     background:    var(--t3-eq-bg);\n     border:        1px solid var(--t3-border-light);\n     border-left:   4px solid var(--t3-amber);\n     border-radius: var(--t3-radius-md);\n     padding:       20px 24px;\n     margin:        18px 0;\n     overflow-x:    auto;\n   }\n   \n   .cre3-eq-box--blue   { border-left-color: var(--t3-blue);   background: var(--t3-blue-dim); }\n   .cre3-eq-box--green  { border-left-color: var(--t3-accent); background: var(--t3-green-dim); }\n   .cre3-eq-box--purple { border-left-color: var(--t3-purple); background: var(--t3-purple-dim); }\n   .cre3-eq-box--red    { border-left-color: var(--t3-red);    background: var(--t3-red-dim); }\n   \n   .cre3-eq-label {\n     font-size:      10px;\n     font-family:    var(--t3-font-mono);\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     color:          var(--t3-text-dim);\n     margin-bottom:  10px;\n   }\n   \n   .cre3-eq-main {\n     font-family: var(--t3-font-mono);\n     font-size:   15px;\n     color:       var(--t3-blue);\n     line-height: 2;\n   }\n   \n   /* KaTeX override: ensure formulas render at comfortable size */\n   .cre3-eq-main .katex { font-size: 1.15em; }\n   .cre3-eq-box .katex  { font-size: 1.1em; }\n   \n   .cre3-eq-note {\n     font-size:   12.5px;\n     color:       var(--t3-text-dim);\n     margin-top:  10px;\n     line-height: 1.6;\n   }\n   \n   /* ─── Equation grid for reactor table ───────────────────────────── */\n   .cre3-reactor-table {\n     width:           100%;\n     border-collapse: collapse;\n     margin:          20px 0;\n     font-size:       13.5px;\n     background:      var(--t3-surface);\n     border-radius:   var(--t3-radius-md);\n     overflow:        hidden;\n     border:          1px solid var(--t3-border-light);\n   }\n   \n   .cre3-reactor-table thead {\n     background: var(--t3-panel);\n   }\n   \n   .cre3-reactor-table th {\n     padding:        11px 16px;\n     text-align:     left;\n     font-family:    var(--t3-font-mono);\n     font-size:      10px;\n     text-transform: uppercase;\n     letter-spacing: 1.5px;\n     color:          var(--t3-text-muted);\n     border-bottom:  1px solid var(--t3-border);\n     font-weight:    500;\n   }\n   \n   .cre3-reactor-table td {\n     padding:       12px 16px;\n     border-bottom: 1px solid var(--t3-border-light);\n     color:         var(--t3-text-muted);\n     vertical-align: middle;\n   }\n   \n   .cre3-reactor-table tr:last-child td { border-bottom: none; }\n   .cre3-reactor-table tr:hover td { background: rgba(40,167,69,0.03); }\n   \n   .cre3-reactor-table .katex { font-size: 1.05em; }\n   \n   /* Reactor label chips */\n   .cre3-reactor-chip {\n     display:        inline-block;\n     font-family:    var(--t3-font-mono);\n     font-size:      10px;\n     text-transform: uppercase;\n     letter-spacing: 1.5px;\n     padding:        3px 9px;\n     border-radius:  20px;\n     font-weight:    600;\n   }\n   .cre3-chip--batch { background: rgba(232,156,0,0.12);  color: var(--t3-batch); }\n   .cre3-chip--cstr  { background: rgba(224,96,58,0.12);  color: var(--t3-cstr); }\n   .cre3-chip--pfr   { background: var(--t3-blue-dim);    color: var(--t3-pfr); }\n   .cre3-chip--pbr   { background: var(--t3-green-dim);   color: var(--t3-pbr); }\n   \n   /* ─── Callout boxes ──────────────────────────────────────────────── */\n   .cre3-callout {\n     border-radius: var(--t3-radius-md);\n     padding:       14px 18px;\n     margin:        18px 0;\n     font-size:     14px;\n     line-height:   1.65;\n   }\n   .cre3-callout p  { color: var(--t3-text-muted); margin: 0; }\n   .cre3-callout--key    { background: var(--t3-blue-dim);   border: 1px solid var(--t3-blue-border); }\n   .cre3-callout--warn   { background: var(--t3-amber-dim);  border: 1px solid var(--t3-amber-border); }\n   .cre3-callout--tip    { background: var(--t3-green-dim);  border: 1px solid var(--t3-green-border); }\n   .cre3-callout--info   { background: var(--t3-cyan-dim);   border: 1px solid var(--t3-cyan-border); }\n   .cre3-callout--purple { background: var(--t3-purple-dim); border: 1px solid var(--t3-purple-border); }\n   \n   /* ─── Card grid ──────────────────────────────────────────────────── */\n   .cre3-card-grid {\n     display:               grid;\n     grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n     gap:                   14px;\n     margin:                20px 0;\n   }\n   \n   .cre3-card {\n     background:    var(--t3-surface);\n     border:        1px solid var(--t3-border-light);\n     border-radius: var(--t3-radius-md);\n     padding:       16px 18px;\n     transition:    border-color 0.18s, box-shadow 0.18s, transform 0.18s;\n     box-shadow:    0 1px 4px rgba(0,0,0,0.04);\n   }\n   .cre3-card:hover {\n     border-color: var(--t3-accent);\n     box-shadow:   0 4px 14px rgba(40,167,69,0.10);\n     transform:    translateY(-2px);\n   }\n   .cre3-card-icon  { font-size: 22px; margin-bottom: 8px; }\n   .cre3-card h4    { font-size: 14px; font-weight: 600; color: var(--t3-text-mid); margin-bottom: 6px; font-family: var(--t3-font-ui); }\n   .cre3-card p     { font-size: 13px; color: var(--t3-text-muted); margin: 0; line-height: 1.5; }\n   \n   /* ─── Comparison cards (2-up) ────────────────────────────────────── */\n   .cre3-two-col {\n     display:               grid;\n     grid-template-columns: 1fr 1fr;\n     gap:                   16px;\n     margin:                20px 0;\n   }\n   \n   @media (max-width: 720px) {\n     .cre3-two-col { grid-template-columns: 1fr; }\n   }\n   \n   /* ─── Steps list ─────────────────────────────────────────────────── */\n   .cre3-steps { margin: 20px 0; }\n   \n   .cre3-step {\n     display:     flex;\n     gap:         16px;\n     margin-bottom: 20px;\n     align-items: flex-start;\n   }\n   \n   .cre3-step-num {\n     min-width:       32px;\n     height:          32px;\n     background:      var(--t3-accent);\n     color:           #fff;\n     border-radius:   50%;\n     display:         flex;\n     align-items:     center;\n     justify-content: center;\n     font-family:     var(--t3-font-mono);\n     font-weight:     600;\n     font-size:       13px;\n     margin-top:      2px;\n     flex-shrink:     0;\n     box-shadow:      0 2px 8px var(--t3-accent-glow);\n   }\n   \n   .cre3-step-content { flex: 1; }\n   .cre3-step-content h4 { font-size: 14px; font-weight: 600; color: var(--t3-text-mid); margin-bottom: 6px; font-family: var(--t3-font-ui); }\n   .cre3-step-content p  { font-size: 13.5px; color: var(--t3-text-muted); margin: 0 0 8px; }\n   \n   /* ─── Example box ────────────────────────────────────────────────── */\n   .cre3-example-box {\n     background:    var(--t3-surface);\n     border:        1px solid var(--t3-border-light);\n     border-top:    3px solid var(--t3-accent);\n     border-radius: var(--t3-radius-md);\n     padding:       20px 24px;\n     margin:        20px 0;\n     box-shadow:    0 2px 10px rgba(0,0,0,0.04);\n   }\n   \n   .cre3-example-tag {\n     font-family:    var(--t3-font-mono);\n     font-size:      10px;\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     color:          var(--t3-accent);\n     margin-bottom:  8px;\n   }\n   \n   .cre3-example-box h4 { font-size: 15px; font-weight: 600; color: var(--t3-text-mid); margin-bottom: 10px; font-family: var(--t3-font-ui); }\n   .cre3-example-box p  { color: var(--t3-text-muted); font-size: 13.5px; margin-bottom: 10px; }\n   \n   /* ─── Inline code ────────────────────────────────────────────────── */\n   .cre3-inline-code {\n     font-family:   var(--t3-font-mono);\n     font-size:     0.88em;\n     background:    var(--t3-code-bg);\n     color:         var(--t3-blue);\n     padding:       2px 5px;\n     border-radius: var(--t3-radius-sm);\n     border:        1px solid var(--t3-border-light);\n   }\n   \n   /* ─── Summary table ──────────────────────────────────────────────── */\n   .cre3-table {\n     width:           100%;\n     border-collapse: collapse;\n     margin:          20px 0;\n     font-size:       13px;\n     background:      var(--t3-surface);\n     border-radius:   var(--t3-radius-md);\n     overflow:        hidden;\n     border:          1px solid var(--t3-border-light);\n   }\n   \n   .cre3-table thead { background: var(--t3-panel); }\n   .cre3-table th    { padding: 10px 14px; text-align: left; font-family: var(--t3-font-mono); font-size: 10px; text-transform: uppercase; letter-spacing: 1.5px; color: var(--t3-text-muted); border-bottom: 1px solid var(--t3-border); font-weight: 500; }\n   .cre3-table td    { padding: 10px 14px; border-bottom: 1px solid var(--t3-border-light); color: var(--t3-text-muted); vertical-align: top; }\n   .cre3-table tr:last-child td { border-bottom: none; }\n   .cre3-table tr:hover td { background: rgba(40,167,69,0.03); }\n   .cre3-table .katex { font-size: 1.0em; }\n   \n   /* ─── Activation energy highlight band ──────────────────────────── */\n   .cre3-energy-band {\n     display:        flex;\n     gap:            12px;\n     align-items:    stretch;\n     margin:         18px 0;\n     flex-wrap:      wrap;\n   }\n   \n   .cre3-energy-block {\n     flex:          1;\n     min-width:     160px;\n     background:    var(--t3-surface);\n     border:        1px solid var(--t3-border-light);\n     border-radius: var(--t3-radius-md);\n     padding:       14px 16px;\n     text-align:    center;\n   }\n   \n   .cre3-energy-block .val {\n     font-family: var(--t3-font-mono);\n     font-size:   22px;\n     font-weight: 600;\n     color:       var(--t3-blue);\n     display:     block;\n     margin-bottom: 4px;\n   }\n   \n   .cre3-energy-block .desc {\n     font-size: 12px;\n     color:     var(--t3-text-dim);\n   }\n   \n   /* ─── Arrhenius highlight card ───────────────────────────────────── */\n   .cre3-arrh-card {\n     background:     linear-gradient(135deg, rgba(40,167,69,0.06) 0%, rgba(74,144,217,0.06) 100%);\n     border:         1px solid var(--t3-green-border);\n     border-radius:  var(--t3-radius-lg);\n     padding:        28px 32px;\n     margin:         24px 0;\n     text-align:     center;\n   }\n   \n   .cre3-arrh-card .cre3-eq-main { font-size: 18px; }\n   .cre3-arrh-card .katex        { font-size: 1.35em; }\n   \n   .cre3-arrh-card p {\n     margin-top: 12px;\n     font-size:  13px;\n     color:      var(--t3-text-dim);\n   }\n   \n   /* ─── Parameter list ─────────────────────────────────────────────── */\n   .cre3-param-list {\n     display:    flex;\n     flex-wrap:  wrap;\n     gap:        12px;\n     margin:     16px 0;\n   }\n   \n   .cre3-param {\n     flex:          1;\n     min-width:     150px;\n     background:    var(--t3-surface);\n     border:        1px solid var(--t3-border-light);\n     border-radius: var(--t3-radius-md);\n     padding:       12px 16px;\n   }\n   \n   .cre3-param-sym {\n     font-family: var(--t3-font-mono);\n     font-size:   18px;\n     color:       var(--t3-blue);\n     font-weight: 600;\n     margin-bottom: 4px;\n   }\n   \n   .cre3-param-name {\n     font-size:  13px;\n     font-weight: 600;\n     color:      var(--t3-text-mid);\n     margin-bottom: 2px;\n   }\n   \n   .cre3-param-unit {\n     font-family: var(--t3-font-mono);\n     font-size:   11px;\n     color:       var(--t3-text-dim);\n   }\n   \n   /* ─── Footer ─────────────────────────────────────────────────────── */\n   .cre3-footer {\n     border-top:  1px solid var(--t3-border-light);\n     padding-top: 24px;\n     margin-top:  40px;\n     color:       var(--t3-text-dim);\n     font-family: var(--t3-font-mono);\n     font-size:   11px;\n   }\n   \n   /* ─── Animation ──────────────────────────────────────────────────── */\n   @keyframes fadeIn3 {\n     from { opacity: 0; transform: translateY(4px); }\n     to   { opacity: 1; transform: translateY(0);   }\n   }\n   \n   /* ─── Responsive ─────────────────────────────────────────────────── */\n   @media (max-width: 1200px) {\n     .cre3-main-inner { padding: 36px 36px 60px; }\n   }\n   \n   @media (max-width: 900px) {\n     .cre3-sidebar { display: none !important; }\n     .cre3-main-inner {\n       padding:   24px 20px 60px;\n       max-width: 100%;\n     }\n     .cre3-toc-grid { grid-template-columns: 1fr; }\n   }\n   \n   @media (max-width: 600px) {\n     .cre3-card-grid { grid-template-columns: 1fr; }\n     .cre3-hero h1   { font-size: 28px; }\n     .cre3-two-col   { grid-template-columns: 1fr; }\n   }\n   "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
